import PerfectScrollbar from 'perfect-scrollbar';

$(window).on('resize',function() {
	if ($('.js-tile-four-scroll').height() > 0 && $(window).width() <= 520) {
		var pstf = new PerfectScrollbar('.js-tile-four-scroll', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength: 180,
			maxScrollbarLength: 180,
			suppressScrollY: true,
			useBothWheelAxes: true
		});
	}
});

$(document).ready(function() {
    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/js/pages/promo/tile-four.js